import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-prensa',
  templateUrl: './prensa.component.html',
  styleUrls: ['./prensa.component.scss']
})
export class PrensaComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
